import { render, staticRenderFns } from "./_themeContent.vue?vue&type=template&id=5fa720c7&lang=pug"
import script from "./_themeContent.vue?vue&type=script&lang=js"
export * from "./_themeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports